module.exports = __webpack_public_path__ + "static/media/Photo 2020-04-08, 6 03 53 PM.05041d55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/social/Photo 2020-04-08, 6 03 53 PM.jpg
// module id = 380
// module chunks = 0